import { Box, Container, Paper } from '@mui/material';
import { PropsWithChildren } from 'react';
import { PublicHeader, PublicFooter } from 'shared/components';

export function PublicLayout({ children }: PropsWithChildren<{}>) {
    return (
        <Box height='calc(100vh - 64px)'>
            <PublicHeader />
            <Container
                sx={{
                    display: 'grid',
                    gridTemplateRows: '90% 10%',
                    height: '100%',
                }}
            >
                <Paper sx={{ alignSelf: 'center' }}>{children}</Paper>
                <PublicFooter />
            </Container>
        </Box>
    );
}
